/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const volume_off = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.4 2.95 5 5.75H3c-.545 0-1 .455-1 1v2m0 4.5 12-10m-6 8.409 1.4.891c.297.223.715.26 1.047.094.332-.166.553-.523.553-.894V9"
    />
  </svg>
)
export default volume_off
